import { useState } from 'react';

export default function TestimonialSection() {
  const testimonials = [
    {
      rating: 4.9,
      text: '정확한 납기와 완벽한 품질로 항상 만족스러운 결과를 제공받고 있습니다. NS-TECH는 신뢰할 수 있는 파트너입니다.',
      name: '김철수 부장',
      company: '삼성전자 구매팀',
      avatar: 'professional korean business manager portrait in formal attire, clean studio background, corporate headshot photography'
    },
    {
      rating: 4.8,
      text: '복잡한 설계도면도 정확하게 구현해주시고, 품질 관리가 철저해서 불량률이 거의 없습니다. 적극 추천합니다.',
      name: '이영희 과장',
      company: 'LG전자 생산관리팀',
      avatar: 'professional korean business woman portrait in business suit, clean studio background, corporate headshot photography'
    },
    {
      rating: 4.9,
      text: '긴급 주문에도 빠르게 대응해주시고, 가격 경쟁력도 우수합니다. 장기 협력사로 함께하고 있습니다.',
      name: '박민수 대리',
      company: '현대자동차 자재팀',
      avatar: 'professional korean business executive portrait in formal wear, clean studio background, corporate headshot photography'
    }
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? testimonials.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev === testimonials.length - 1 ? 0 : prev + 1));
  };

  const current = testimonials[currentIndex];

  return (
    <section id="support" className="py-24 px-16 bg-gray-50">
      <div className="max-w-4xl mx-auto">
      </div>
    </section>
  );
}